module.exports = __webpack_public_path__ + "img/5f_r_twodays.526b359d.jpg";